var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeys(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.747,9.558A2.808,2.808,0,1,0,3.94,6.75,2.807,2.807,0,0,0,6.747,9.558ZM3.541,3.537A6.853,6.853,0,0,1,14.7,11.054a.766.766,0,0,0,.163.84l7.6,7.606v2.969H19.5l-.748-.748v-1.8a.985.985,0,0,0-.985-.985H16.1V17.274a.985.985,0,0,0-.985-.985h-1.8l-1.424-1.424a.764.764,0,0,0-.839-.164A6.853,6.853,0,0,1,3.539,3.542ZM11.16,16.3l1.128,1.128a1.272,1.272,0,0,0,.949.393h1.335v1.129A1.532,1.532,0,0,0,16.1,20.48h1.129v1.332a1.348,1.348,0,0,0,.385.94l.885.885a1.251,1.251,0,0,0,.884.363H22.9A1.1,1.1,0,0,0,24,22.9V19.385a1.248,1.248,0,0,0-.367-.888L16.3,11.161A8.384,8.384,0,1,0,11.16,16.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeys);
export default __webpack_public_path__ + "static/media/Keys.536e9b82d34f170f952b64f51ff54b10.svg";
export { ForwardRef as ReactComponent };